// extracted by mini-css-extract-plugin
module.exports = {"socialCont":"socialStyles-module--socialCont--OYWCw","socialIcon":"socialStyles-module--socialIcon--2V4Re"};